export default __webpack_public_path__ + "static/media/Cotizacion.6cfaecc7.svg";